import styled from 'styled-components';

import { Text } from '@components/Text/Text';
import { CommonContainer, CommonOuter } from '../common';

import { Colors, Flex, Media } from '@styles';

export const Outer = styled(CommonOuter)``;

export const Container = styled(CommonContainer)`
  padding: 129.5px 73px;

  ${Media.mobile} {
    flex-direction: column-reverse;
    align-items: flex-start;

    padding: 60px 30px;
  }
`;

export const ImageContainer = styled.div``;

export const PhoneImage = styled.img`
  width: auto;
  height: 541px;

  ${Media.mobile} {
    width: 100%;
    max-width: 500px;
    height: auto;
    margin-top: 80px;
  }
`;

export const TextContainer = styled.div`
  ${Flex.Column};
`;

export const AccentText = styled(Text.H4)`
  margin-bottom: 20px;

  color: ${Colors.blue400};

  ${Media.mobile} {
    margin-bottom: 16px;
  }
`;

type HeadTextProps = {
  marginBottom?: number;
};
export const HeadText = styled(Text.H2)<HeadTextProps>`
  margin-bottom: ${(props) => props.marginBottom ?? 0}px;
`;

export const DescriptionText = styled(Text.H4)`
  margin-top: 20px;

  color: ${Colors.gray500};

  ${Media.mobile} {
    margin-top: 16px;
  }
`;
